import Vue from 'vue'
import Router from 'vue-router'

const h5set = resolve => require(['@/pages/h5/login/set'], resolve)
const h5login = resolve => require(['@/pages/h5/login/login'], resolve)
const surveyLogin = resolve => require(['@/pages/h5/login/surveyLogin'], resolve)
const familylogin = resolve => require(['@/pages/h5/login/familylogin'], resolve)
const sqlogin = resolve => require(['@/pages/h5/login/sqlogin'], resolve)
// const h5newUser = resolve => require(['@/pages/h5/login/newUser'], resolve)
const pclogin = resolve => require(['@/pages/pc/login/login'], resolve)
// const h5changePhoneNumber = resolve => require(['@/pages/h5/login/changePhoneNumber'], resolve)
// const h5nextChangePhone = resolve => require(['@/pages/h5/login/nextChangePhone'], resolve)
// const h5resetPassword = resolve => require(['@/pages/h5/login/resetPassword'], resolve)
const h5init = resolve => require(['@/pages/h5/login/init'], resolve)
// const nextResetPassword = resolve => require(['@/pages/h5/login/nextResetPassword'], resolve)
// const findPassword = resolve => require(['@/pages/h5/login/findPassword'], resolve)
// const nextFindPassword = resolve => require(['@/pages/h5/login/nextFindPassword'], resolve)
const pcnewUser = resolve => require(['@/pages/pc/login/newUser'], resolve)
const forgetPass = resolve => require(['@/pages/pc/login/forgetPass'], resolve)
const text = resolve => require(['@/pages/pc/login/text'], resolve)
const pcinit = resolve => require(['@/pages/pc/login/init'], resolve)
const loginMiddleWare = resolve => require(['@/pages/h5/login/loginMiddleWare'], resolve)
// 登录协议
// 2019/7/5新增
const register = resolve => require(['@/pages/h5/bindmobile/index'], resolve)
const loginagreement = resolve => require(['@/pages/h5/login/loginagreement'], resolve)
const yinsagreement = resolve => require(['@/pages/h5/login/yinsagreement'], resolve)
const wxactivity = resolve => require(['@/pages/h5/wxactivity/index'], resolve)
// 加群二维码
const qrcodeauth = resolve => require(["@/pages/qrcode/index.vue"], resolve)
// 2019/12/2 新增APP扫码登录
const codelogin = resolve => require(['@/pages/h5/codeLogin/index'], resolve)
// 2022/8/15  新增鲸吞H5授权
const jtAuthorize = resolve => require(['@/pages/h5/jt/jtAuthorize'], resolve)
// 2022/9/20  新增鲸吞内容站点微信名片中转授权页面
const wxVCard = resolve => require(['@/pages/h5/jt/wxVCard'], resolve)
// 2020/08/04 登录获取用户信息
const getinfologin = resolve => require(['@/pages/h5/login/getinfologin'], resolve)
// 退出登录
const loginout = resolve => require(['@/pages/loginout'], resolve)
const gzhlogin = resolve => require(['@/pages/h5/login/gzhlogin'], resolve)
const cancellation = resolve => require(['@/pages/cancellation/index'], resolve)
const getuserId = resolve => require(['@/pages/cancellation/getid'], resolve)
const cancellationTips = resolve => require(['@/pages/cancellation/tips'], resolve)
// const testlogin = resolve => require(['@/pages/testlogin'], resolve)
const clientlogin = resolve => require(['@/pages/windows/login/login'], resolve)
const clientloading = resolve => require(['@/pages/windows/loading'], resolve)

const recordLogin = resolve => require(['@/pages/pc/login/recordLogin'], resolve)
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      redirect: '/h5/login'
    },
    {
      path: "/h5/qrcodeauth",
      component: qrcodeauth,
      meta: {
        title: "橙啦"
      }
    },
    {
      path: '/h5/bindmobile',
      component: register,
      meta: {
        title: '绑定注册手机'
      }
    },
    {
      path: '/h5/wxactivity',
      component: wxactivity,
      meta: {
        title: '橙啦过级礼包'
      }
    },
    {
      path: '/h5/login',
      component: h5login,
      meta: {
        title: '登录'
      }
    },
    {
      path: '/h5/surveyLogin',
      component: surveyLogin,
      meta: {
        title: '问卷登录'
      }
    },
    {
      path: '/h5/sqlogin',
      component: sqlogin,
      meta: {
        title: '授权登录'
      }
    },
    {
      path: '/h5/set',
      component: h5set,
      meta: {
        title: 'h5'
      }
    },
    {
      path: '/h5/init',
      component: h5init,
      meta: {
        title: '完善个人信息'
      }
    },
    // {
    //   path: '/h5/newUser', // 暂时不介入阿里智能验证，使用频率过少。一个月仅查询到一次
    //   component: h5newUser,
    //   meta: {
    //     title: '注册'
    //   }
    // },
    // {
    //   path: '/h5/changePhone',
    //   component: h5changePhoneNumber,// 暂时不介入阿里智能验证，使用频率过少。一个月仅查询到一次
    //   meta: {
    //     title: '修改手机号'
    //   }
    // },
    // {
    //   path: '/h5/nextChPhone',
    //   component: h5nextChangePhone, // 暂时不介入阿里智能验证，使用频率过少。一个月仅查询到一次
    //   meta: {
    //     title: '修改手机号'
    //   } // 修改手机号的验证码页
    // },
    // {
    //   path: '/h5/resetPwd',
    //   component: h5resetPassword, // 暂时不介入阿里智能验证，使用频率过少。一个月仅查询到一次
    //   meta: {
    //     title: '重置密码'
    //   } // 重置密码
    // },
    // {
    //   path: '/h5/nextResetPwd',
    //   component: nextResetPassword, // 暂时不介入阿里智能验证，使用频率过少。一个月仅查询到一次
    //   meta: {
    //     title: '重置密码'
    //   } // 重置密码的验证码
    // },
    // {
    //   path: '/h5/forgetPass', // 暂时不介入阿里智能验证，使用频率过少。一个月仅查询到一次
    //   component: findPassword,
    //   meta: {
    //     title: '找回密码'
    //   } // 找回密码也就是忘记密码的操作
    // },
    // {
    //   path: '/h5/nextFindPwd', // 暂时不介入阿里智能验证，使用频率过少。一个月仅查询到一次
    //   component: nextFindPassword,
    //   meta: {
    //     title: '找回密码'
    //   } // 找回密码的手机验证码页
    // },
    {
      path: '/pc/login',
      component: pclogin,
      meta: {
        title: '登录'
      }
    },
    {
      path: '/pc/newUser',
      component: pcnewUser,
      meta: {
        title: '注册'
      }
    },
    {
      path: '/pc/init',
      component: pcinit,
      meta: {
        title: '完善个人信息'
      }
    },
    {
      path: '/pc/forgetPass',
      component: forgetPass,
      meta: {
        title: '忘记密码'
      }
    },
    {
      path: '/pc/text',
      component: forgetPass,
      meta: {
        title: '找回密码'
      }
    },
    {
      path: '/pc/yinsagreement',
      component: yinsagreement,
      meta: {
        title: '橙啦隐私条款'
      }
    },
    {
      path: '/h5/loginagreement',
      component: loginagreement,
      meta: {
        title: '橙啦用户协议'
      }
    },
    {
      path: '/h5/yinsagreement',
      component: yinsagreement,
      meta: {
        title: '橙啦隐私条款'
      }
    },
    {
      path: '/h5/codelogin',
      component: codelogin,
      meta: {
        title: '扫码登录'
      }
    },
    {
      path: '/h5/jt/jtAuthorize',
      component: jtAuthorize,
      meta: {
        title: 'H5授权'
      }
    },
    {
      path: '/h5/jt/wxVCard',
      component: wxVCard,
      meta: {
        title: '微信名片'
      }
    },
    {
      path: '/h5/loginMiddleWare',
      component: loginMiddleWare,
      meta: {
        title: '笃局'
      }
    },
    {
      path: '/h5/live',
      component: getinfologin,
      meta: {
        title: '授权登录'
      }
    },
    {
      path: '/pc/live',
      component: getinfologin,
      meta: {
        title: '授权登录'
      }
    },
    {
      path: '/pc/recordLogin',
      component: recordLogin,
      meta: {
        title: '授权登录'
      }
    },
    {
      path: '/loginout',
      component: loginout,
      meta: {
        title: '退出登录'
      }
    },
    {
      path: '/h5/gzhlogin',
      component: gzhlogin,
      meta: {
        title: '公众号'
      }
    },
    {
      path: '/cancellation',
      component: cancellation,
      meta: {
        title: '注销账户风险'
      }
    },
    {
      path: '/cancellationTips',
      component: cancellationTips,
      meta: {
        title: '注销须知'
      }
    },
    {
      path: '/getuserId',
      component: getuserId,
      meta: {
        title: '获取用户ID'
      }
    },
    {
      path: '/familylogin',
      component: familylogin,
      meta: {
        title: '家庭教育告知书'
      }
    },
    {
      path: '/windows/login',
      component: clientlogin,
      meta: {
        title: '登录'
      }
    },
    {
      path: '/windows/loading',
      component: clientloading,
      meta: {
        title: '登录中~'
      }
    }
    // {
    //   path: '/testlogin',
    //   component: testlogin
    // }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js